/*******************************************************************************
  Upgrading client local state to the latest system version.
*******************************************************************************/

import localStorage from './localStorage';
import webApp from './webApp';

/**
 * Normalizes a version string (e.g. '5.0.0') into an integer, so that we can 
 * easily compare version strings with different amount of characters, like 
 * '5.0.123' and '6.0.1'.
 */
function versionToInt( systemVersionStr ) {

  if ( typeof systemVersionStr !== 'string' && typeof systemVersionStr !== 'number' )
    return 0;

  var nr = '';
  var parts = systemVersionStr.split( '.' );
  // Version string must have 3 parts
  if ( parts.length < 3 ) {
    for ( var i = parts.length; i < 3; i++ )
      parts.push( '0' );
  }
  // Max supported version number is '999.999.999', i.e. 3 digits per part
  for ( var i = 0; i < parts.length; i++ ) {
    // Right-pad all parts with zeroes
    for ( var j = parts[ i ].length; j < 3; j++ )
      parts[ i ] = '0'+ parts[ i ];
    nr += parts[ i ];
  }
  
  return parseInt( nr, 10 );
}

function do600Upgrades() {
  // Asteikko Mag 6.0.0 is a large refactor, and any local state is probably
  // out of date, so we remove all local Asteikko Mag state
  try {
    for ( var i in window.localStorage ) {
      if ( /^asmag/.test( i ) )
        window.localStorage.removeItem( i );
    }
  }
  catch ( e ) {
    webApp.console.warn( e );
  }
}

const upgrades = {
  doUpgrades( systemVersion ) {

    var localVersion = localStorage.get( 'asmag_system_version' );

    webApp.console.log( 'Newest system version: '+ systemVersion );
    webApp.console.log( 'Local system version: '+ localVersion );

    try {

      var localVersionInt = versionToInt( localVersion );

      if ( localVersionInt < versionToInt( '6.0.0' ) )
        do600Upgrades();
    }
    catch ( e ) {
      webApp.console.error( e );
    }

    localStorage.set( 'asmag_system_version', systemVersion );
  }
};

export default upgrades;
